import * as HttpService from './http.service';
import { getQueueJobRecords } from './queue-jobs.service';
import { POLLING_STATUS_URL } from './url.service';

export const getPollingStatus = (body) => HttpService.postWithAuth(POLLING_STATUS_URL, body, false);

const delay = (delayInMs = 1000) => new Promise((resolve) => { setTimeout(() => { resolve(); }, delayInMs) })

export const recursiveCallUntillResultAvailable = async ({
    callInMs = 1000,
    resultAvailable = false,
    pollingStatusResult,
    onSuccess = () => { },
    pollingStatusCb = async () => { },
    onError = () => { }
}) => {
    if (resultAvailable) {
        return pollingStatusResult;
    }
    await delay(callInMs);
    const rs = await pollingStatusCb();
    const { status, entity } = rs || {};
    if (status) {
        const { isResultAvailable, result, isFailed } = entity;
        if (isFailed) {
            onError(entity)
            return
        }
        if (isResultAvailable) {
            onSuccess({
                result
            });
            return recursiveCallUntillResultAvailable({
                resultAvailable: isResultAvailable,
                pollingStatusResult: result,
                pollingStatusCb,
                onSuccess
            });

        }
        return recursiveCallUntillResultAvailable({
            resultAvailable: false,
            pollingStatusCb,
            onSuccess
        });
    } else {
        onError(entity)
    }

}

export const recursiveCallPollingStatus = ({
    type = 'availability-report-export', jobId, setProcessingFileData, onComplete = () => { }
}) => {
    recursiveCallUntillResultAvailable({
        callInMs: 5000,
        resultAvailable: false,
        onSuccess: ({ result }) => {
            window.open(result.downloadLink, '_blank');
            onComplete();
            setProcessingFileData((prevVal) => ({ ...prevVal, isLoading: false, processedRecords: result?.entity?.result?.processedRecords || prevVal.processedRecords }));
        },
        pollingStatusCb: async () => {
            const result = await getPollingStatus({
                messageUniqueId: jobId,
                type
            });

            setProcessingFileData((prevVal) => ({ ...prevVal, isLoading: true, processedRecords: result?.entity?.result?.processedRecords || prevVal.processedRecords }));

            return result;
        },
        onError: async () => {
        }
    })
}

export const recursiveCallPollingStatusWhenFailed = async ({
    type = 'availability-report-export', jobId, prevResult = { status: false, errorMessage: 'job not available' },
    setLoading, setFiles,
    router,
    setToastData = () => { }
}) => {
    let retryAttempt = 0;
    const recursiveCall = async ({ jobId, prevResult }) => {
        const { status, errorMessage, entity } = prevResult
        if (status) {
            if (entity?.isResultAvailable && !entity?.noRecordsFound) {
                await delay(3000);
                if (entity?.result?.downloadLink) {
                    window.open(entity?.result?.downloadLink, '_blank');
                    if (entity?.result?.downloadLink?.includes('propel-report-dump')) {
                        setToastData({ show: true, message: 'Your Propel Report has been exported successfully!', type: 'success' });
                    }
                }
                router.replace('/download-history', undefined, { shallow: false });
                const queueJobResult = await getQueueJobRecords();                
                if (queueJobResult.status) {
                    setFiles(queueJobResult.entity);
                }
                setLoading(false);
                return;
            }
            if(entity?.isResultAvailable && entity?.noRecordsFound) {
                setToastData({ show: true, message: "There is no data to be exported. Please try removing some filters. The export process is not initiated in this case", type: 'error' })
                router.replace('/download-history', undefined, { shallow: false });
                await delay(3000);
                await setLoading(false);
              return;
            }
            await delay(2000);

            const [pollingResult, queueJobResult] = await Promise.all([
                getPollingStatus({
                    messageUniqueId: jobId,
                }),
                getQueueJobRecords()
            ]);            

            if (pollingResult.status && queueJobResult.status && !queueJobResult.entity.find(({ id }) => id === jobId)) {
                recursiveCall({ jobId, prevResult: pollingResult });
                return
            }

            if (queueJobResult.status && queueJobResult.entity.find(({ id }) => id === jobId)) {
                setFiles(queueJobResult.entity);
            }
            if (pollingResult.status && pollingResult?.entity?.isResultAvailable) {
                const { result } = pollingResult.entity;
                await delay(3000);
                window.open(result.downloadLink, '_blank');
                if (result?.downloadLink?.includes('propel-report-dump')) {
                    setToastData({ show: true, message: 'Your Propel Report has been exported successfully!', type: 'success' });
                }
            }
            setLoading(false);
            router.replace('/download-history', undefined, { shallow: false });
        }
        else if (errorMessage == 'job not available') {
            const result = await getPollingStatus({
                messageUniqueId: jobId,
            });
            await delay(2000);
            if (retryAttempt < 300) {
                retryAttempt++;
                recursiveCall({ jobId, prevResult: result })
            } else {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    }

    recursiveCall({ jobId, prevResult })
}